import { useToast } from "@/shared/lib"
import { AppInfoStore, ConfigStore } from "@/shared/model/store"
import { useEffect, useState } from "react"
import { checkIpfsConnection, pinToFilebase, uploadFileToIPFS } from "./utils";
import { Link } from "react-router-dom";
import { Button } from "@/shared/ui";


/*
{
    "requestid": "Z2lkOi8vZmlsZWJhc2UvQXNzZXQvMTkyNTAxNjkxMw",
    "status": "queued",
    "created": "2025-07-22T12:34:45.000-04:00",
    "pin": {
        "cid": "QmdReQaYm4ZJDbVuf8Sob9dJZMTA7Drwxzh7Jd6ewhnjQ4",
        "name": "pinned-1753202084452",
        "origins": [],
        "meta": {}
    },
    "info": {
        "size": "0"
    },
    "delegates": [
        "/dns4/ipfs-pin-0.vin1.filebase.io/tcp/4001/p2p/12D3KooWNvyc1NoeTF6SynHuq5exmsMs7YyE1UFp9YhsiYw2px9B",
        "/dns4/ipfs-pin-1.vin1.filebase.io/tcp/4001/p2p/12D3KooWC8RkG22G2Jp7wdBtMDxG4LLn6d3sDfqtqXBytpyNhXTM",
        "/dns4/ipfs-pin-2.vin1.filebase.io/tcp/4001/p2p/12D3KooW9x6zfqWH46VYQoFDdfPuQqoc56L359NM6pQedrSHrv6R"
    ]
}
*/



const useIpfs = () => {
    const [loaded, setLoaded] = useState(false)
    const { localGateway, setLocalGateway } = ConfigStore()
    const { appInfo: { ipfs_gateways }} = AppInfoStore()
    const { toast } = useToast()

    const checkIpfs = async () => {
        const connecter = await checkIpfsConnection()
        if(!connecter.connected) {
            toast({
            duration: 15000,
            key: 'IPFS_ERROR',
            title: 'IPFS is not running or some other error',
            variant: 'destructive'
        })
        }
        setLocalGateway({
                ...localGateway,
                error: connecter.connected ? '' : 'IPFS is not running',
                on_air: !!connecter.connected
        })
        setLoaded(true)
    }

    const pin = async (file: File) => {
        const CONFIG: any = {
            duration: 5000,
            key: 'IPFS_UPLOAD',
            title: 'Store to local IPFS',
            variant: 'default',
            closeable: true
        }
        toast({
            ...CONFIG,
            description: 'Store to local IPFS (1 of 2)',
        })
        const cid = await uploadFileToIPFS(file)
        toast({
            ...CONFIG,
            description: 'Pin to public IPFS (2 of 2)',
        })
        const pintoipfs = await pinToFilebase(cid)
        if(!pintoipfs.success){
            toast({
                ...CONFIG,
                title: `IPFS ERROR: ${pintoipfs.data.reason}`,
                description: `${pintoipfs.data.details}`,
                variant: 'destructive',
                action: <Link to='/browser-settings'><Button variant={'outline_destructive'}>Open settings</Button></Link>
            })
            return false
        } else {
            toast({
                ...CONFIG,
                title: 'IPFS pinned',
                variant: 'sucsess'
            })
             return cid
        }       
    }


    useEffect(() => {
        if(!localGateway.enable) {
            setLoaded(true)
            return
        }
        checkIpfs()
    }, [localGateway.enable])

    return {
        gateway: localGateway.enable ? localGateway.ipfs_link : ipfs_gateways[0],
        on_air: localGateway.on_air,
        ipfs_error: localGateway.error,
        loaded,
        pin,
    }
}

export default useIpfs